<div class="p-dynamic-dialog-body">
    <div class="form-horizontal form-width-dynamic" [formGroup]="sampleBarcodeGroup">
        <div class="form-group">
            <div class="form-label-div">
                <span class="form-label">{{'vbeiBarcodeLabelTemplate' | translate}}</span>
            </div>
            <div class="form-input-div">
                <div class="flex-grow">
                    <p-dropdown [options]="reportTemplateValues" formControlName="reportTemplate" appendTo="body" [baseZIndex]="11000"
                        (onChange)="onReportTemplateChange()"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="form-group" *ngIf = "enableSmartLabelPrinting">
            <div class="form-label-div">
                <span class="form-label">{{'vbeiPrintingOn'| translate}}</span>
            </div>
            <div class="form-input-div">
                <div class="flex-body flex-column printing-on-group">
                    <p-radioButton class="printing-on" name="printingOn" value="{{printingOnType.EMPTY}}"
                        label="{{printingOnType.EMPTY}}" formControlName="printingOn"
                        (onClick)="updatePrintingOn(printingOnType.EMPTY)"></p-radioButton>
                    <p-radioButton class="printing-on" name="printingOn" value="{{printingOnType.CONTAINING}}"
                        label="{{printingOnType.CONTAINING}}" formControlName="printingOn"
                        (onClick)="updatePrintingOn(printingOnType.CONTAINING)"></p-radioButton>
                </div>
            </div>
        </div>
        <div class="form-group" *ngIf="printingOn === printingOnType.CONTAINING && enableSmartLabelPrinting">
            <div class="form-label-div"></div>
            <div class="form-input-div">
                <div class="flex-body align-items-center">
                    <span class="no-wrap m-r-12">{{'vbeiBarcodesAlreadyPrinted' | translate}}</span>
                    <div class="p-input-number barcode-count" [appInputNumber]="ipt"
                        (update)="onNoOfBarcodeUpdate($event)">
                        <input #ipt type="text" pInputText maxlength="3" pKeyFilter="pint"
                            formControlName="noOfBarcode"
                            [ngClass]="{'has-error':
                            sampleBarcodeGroup.get('noOfBarcode').errors &&
                            (sampleBarcodeGroup.get('noOfBarcode').dirty ||
                            sampleBarcodeGroup.get('noOfBarcode').touched)}" />

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="p-dynamic-dialog-footer">
    <div class="flex-body">
        <div class="align-right">
            <button type="button" pButton (click)="onDownloadBarCodeClick()" label="{{'vbeiDownloadBarcodes' | translate}}"></button>
        </div>
    </div>
</div>
